import { createSlice } from "@reduxjs/toolkit";
import { fetchAdaRequestsAction, discardAdaRequestAction } from "../Actions/AdminAdaRequestsAction";

const initialState = {
  adaRequestsData: {},
  isLoading: false,
};

const adminAdaRequestsSlice = createSlice({
  name: "adminAdaRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdaRequestsAction.pending, (state) => {
        state.isLoading = true;
        state.adaRequestsData = {};
      })
      .addCase(fetchAdaRequestsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adaRequestsData = action.payload;
      })
      .addCase(fetchAdaRequestsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.adaRequestsData = action.payload;
      })
      .addCase(discardAdaRequestAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(discardAdaRequestAction.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(discardAdaRequestAction.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const adminAdaRequestsReducer = adminAdaRequestsSlice.reducer;
